import { getSystemTemplates } from '../data/systemIndustryTemplates';

/**
 * RAG Knowledge Service
 * Extracts and provides static knowledge from system templates
 */
export const ragKnowledgeService = {
  /**
   * Get static keywords from industry templates for a specific industry
   */
  getStaticKeywords(industry: string): string[] {
    const templates = getSystemTemplates();
    const targetIndustry = industry.toLowerCase();
    
    // Find matching template
    const template = templates.find(t => 
      t.industry.toLowerCase() === targetIndustry || 
      t.name.toLowerCase().includes(targetIndustry)
    );

    if (!template) return [];

    // Extract keywords from markdown content
    // Look for lines starting with "- " in the Keywords Strategy section
    const keywords: string[] = [];
    const lines = template.markdownContent.split('\n');
    let inKeywordsSection = false;

    for (const line of lines) {
      if (line.includes('Keywords Strategy') || line.includes('Keywords INCLUDE')) {
        inKeywordsSection = true;
        continue;
      }
      if (inKeywordsSection && line.startsWith('##')) {
        inKeywordsSection = false;
        continue;
      }
      
      if (inKeywordsSection && line.trim().startsWith('- "')) {
        // Extract content between quotes
        const match = line.match(/"([^"]+)"/);
        if (match && match[1]) {
          keywords.push(match[1]);
        }
      }
    }

    return keywords;
  },

  /**
   * Get industry-specific negative keywords
   */
  getNegativeKeywords(industry: string): string[] {
    const templates = getSystemTemplates();
    const targetIndustry = industry.toLowerCase();
    
    const template = templates.find(t => 
      t.industry.toLowerCase() === targetIndustry || 
      t.name.toLowerCase().includes(targetIndustry)
    );

    if (!template) return [];

    const negatives: string[] = [];
    const lines = template.markdownContent.split('\n');
    let inNegativesSection = false;

    for (const line of lines) {
      if (line.includes('Negative Keywords') || line.includes('EXCLUDE')) {
        inNegativesSection = true;
        continue;
      }
      if (inNegativesSection && line.startsWith('##')) {
        inNegativesSection = false;
        continue;
      }
      
      if (inNegativesSection && line.trim().startsWith('- "')) {
        const match = line.match(/"([^"]+)"/);
        if (match && match[1]) {
          negatives.push(match[1]);
        }
      }
    }

    return negatives;
  }
};

